export default "__VITE_ASSET__Bv9C9Kll__"